/**
 * Loads a script dynamically by creating a <script> element and appending it to the document head.
 * @param scriptSrc - The URL of the script to load.
 * @returns A Promise that resolves when the script has been successfully loaded, or rejects if an error occurs.
 */

export const loadScript = (scriptSrc: string): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = scriptSrc
    script.onload = resolve
    script.onerror = reject
    document.head.appendChild(script)
  })
}
